// extracted by mini-css-extract-plugin
export default {"root":"gift_card_store_detail_page_root__VE1Wo"};